// extracted by mini-css-extract-plugin
var _1 = "TabStash_items__f927f";
var _2 = "TabStash_root__ab91e";
var _3 = "TabStash_title__ca3ed";
export { _1 as "items", _2 as "root", _3 as "title" }
